import {
  Flex,
  IconButton,
  IconEditLine,
  IconTrashLine,
  List,
} from "@instructure/ui";
import { t } from "i18next";
import React, { useState } from "react";
import { GoalsService } from "../../../services/CyclesService";
import { Card } from "../../Card";
import { ERROR, useNotification } from "../../CustomHooks/NotificationProvider";
import { DialogYesNo } from "../../DialogYesNo";
import { CycleGoalEditModal } from "./CycleGoalEditModal";

const GoalEntry = ({ goal, setGoals }) => {
  const showNotification = useNotification();
  const [openEditModal, setOpenEditModal] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);

  async function handleDeleteGoal() {
    try {
      await GoalsService.deleteGoal(goal);
      const objectivePromises = goal.objectives.map((objective) =>
        GoalsService.deleteGoalObjective(objective)
      );
      await Promise.all(objectivePromises);

      setGoals((prevGoals) => prevGoals.filter((g) => g.id !== goal.id));
      setConfirmDelete(false);
      showNotification(
        t("notifications.general.deleteSuccess", {
          obj: t("cyclesAndGoals.cycleGoal.goal"),
        })
      );
    } catch {
      showNotification(
        t("notifications.general.deleteError", {
          obj: t("cyclesAndGoals.cycleGoal.goal"),
        }),
        ERROR
      );
    }
  }

  return (
    <Card
      style={{
        backgroundColor: "#F2F8FA",
        border: "1px solid #ccc",
        borderRadius: "10px",
        padding: "5px 15px",
        marginBottom: 15,
      }}
    >
      <Flex gap="small">
        <Flex.Item shouldGrow>
          {goal.description}
          <List>
            {goal.objectives.map((obj) => (
              <List.Item key={obj.id}>{obj.description}</List.Item>
            ))}
          </List>
        </Flex.Item>
        <Flex.Item>
          <IconButton
            renderIcon={IconEditLine}
            screenReaderLabel={t("cyclesAndGoals.cycleGoal.editGoal")}
            onClick={() => setOpenEditModal(true)}
          />
        </Flex.Item>
        <Flex.Item>
          <IconButton
            renderIcon={IconTrashLine}
            screenReaderLabel={t("cyclesAndGoals.cycleGoal.deleteGoal")}
            onClick={() => setConfirmDelete(true)}
          />
        </Flex.Item>
      </Flex>
      <CycleGoalEditModal
        goal={goal}
        open={openEditModal}
        setOpen={setOpenEditModal}
        setGoals={setGoals}
      />
      <DialogYesNo
        message={t("cyclesAndGoals.cycleGoal.deleteCycleGoal")}
        openStatus={confirmDelete}
        onClickNo={() => setConfirmDelete(false)}
        onClickYes={handleDeleteGoal}
      />
    </Card>
  );
};

export default GoalEntry;
